
export type GetApiV1RefundsEligibilityOrderId200AllOfThreeData = {
  /** AI API 사용 횟수 */
  aiUsageCount?: number;
  /** 환불 가능 여부 */
  canRefund?: boolean;
  /** 주문 ID */
  orderId?: string;
  /** 환불 가능/불가능 사유 */
  reason?: string;
  /** 환불 가능 금액 */
  refundableAmount?: number;
  /** 구독 금액 */
  subscriptionAmount?: number;
};
